var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('md-content',[_c('viewer',{attrs:{"content":true,"embed":true,"mode":_vm.mode,"nid":_vm.nid,"sid":_vm.sid,"field":"field_ready_form"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }